import {
    SELECT_COUNTRY,
    SET_PROVINCE_STATE,
    SET_CITY,
    SET_ADDRESS,
    SET_POSTAL_CODE,
    CLEAR_SHIPPING_INFO,
} from 'Actions/shipping';

const initialState = {
    country: "",
    provinceState: "",
    city: "",
    address: "",
    postalCode: ""
};

export default function shipping(state = initialState, action) {
    switch (action.type) {
        case SELECT_COUNTRY:
            return { ...state, country: action.country };
        case SET_PROVINCE_STATE:
            return { ...state, provinceState: action.provinceState };
        case SET_CITY:
            return { ...state, city: action.city };
        case SET_ADDRESS:
            return { ...state, address: action.address };
        case SET_POSTAL_CODE:
            return { ...state, postalCode: action.postal_code };
        case CLEAR_SHIPPING_INFO:
            return initialState;
        default:
            return state;
    }
};